<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <DrugTabLinks />

                    <DrugUpsertForm
                        class="mt-4"
                        :entity="entity"
                        @success="$router.push(`/pharmacies/${$route.params.id}/drugs/${$route.params.drug_id}`)"
                        @deleted="$router.push(`/pharmacies/${$route.params.id}/drugs`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js'
    import DrugTabLinks from '@/components/pharmacies/DrugTabLinks'
    import DrugUpsertForm from '@/components/pharmacies/DrugUpsertForm'

    export default {
        components: {
            DrugTabLinks,
            DrugUpsertForm,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch()
        },

        methods: {
            async fetch() {
                const { id, drug_id } = this.$route.params

                const [error, result] = await to(this.axios.get(`/pharmacies/${id}/drugs/${drug_id}`))
                this.entity = result.data

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении лекарства. ' + error);
                }
            }
        }
    }
</script>
